import axios from 'axios'

const apiUrl = 'https://sitebypro-server.ru/druzbamebel'
const TOKEN_KEY = 'druzhba_admin_token'

function savedToken() {
  try { return window.sessionStorage.getItem(TOKEN_KEY) || '' } catch (_) { return '' }
}

export default {
  state: {
    logged: false,
    checking: true,
    token: savedToken(),
    error: ''
  },
  getters: {
    logged(state) { return state.logged },
    adminChecking(state) { return state.checking },
    adminToken(state) { return state.token },
    adminError(state) { return state.error }
  },
  mutations: {
    SET_LOGGED(state, value) { state.logged = Boolean(value) },
    SET_ADMIN_CHECKING(state, value) { state.checking = Boolean(value) },
    SET_ADMIN_ERROR(state, value) { state.error = String(value || '') },
    SET_ADMIN_TOKEN(state, token) {
      state.token = String(token || '')
      try {
        if (state.token) window.sessionStorage.setItem(TOKEN_KEY, state.token)
        else window.sessionStorage.removeItem(TOKEN_KEY)
      } catch (_) {}
    }
  },
  actions: {
    async RESTORE_ADMIN_SESSION({ state, commit }) {
      commit('SET_ADMIN_CHECKING', true)
      commit('SET_ADMIN_ERROR', '')
      if (!state.token) {
        commit('SET_LOGGED', false)
        commit('SET_ADMIN_CHECKING', false)
        return false
      }
      try {
        const response = await axios.post(`${apiUrl}/admin/verify`, { admin_token: state.token })
        const valid = String(response && response.data && response.data.status) === '200'
        commit('SET_LOGGED', valid)
        if (!valid) commit('SET_ADMIN_TOKEN', '')
        return valid
      } catch (_) {
        commit('SET_ADMIN_TOKEN', '')
        commit('SET_LOGGED', false)
        return false
      } finally {
        commit('SET_ADMIN_CHECKING', false)
      }
    },
    async ADMIN_LOGIN({ commit }, password) {
      commit('SET_ADMIN_CHECKING', true)
      commit('SET_ADMIN_ERROR', '')
      try {
        const response = await axios.post(`${apiUrl}/admin/login`, { password: String(password || '') })
        const payload = response && response.data && response.data.data
        if (String(response && response.data && response.data.status) !== '200' || !payload || !payload.token) {
          throw new Error(payload && payload.text ? payload.text : 'Неверный пароль')
        }
        commit('SET_ADMIN_TOKEN', payload.token)
        commit('SET_LOGGED', true)
        return true
      } catch (error) {
        const payload = error && error.response && error.response.data && error.response.data.data
        commit('SET_ADMIN_ERROR', payload && payload.text ? payload.text : error.message || 'Не удалось выполнить вход')
        commit('SET_LOGGED', false)
        return false
      } finally {
        commit('SET_ADMIN_CHECKING', false)
      }
    },
    ADMIN_LOGOUT({ commit }) {
      commit('SET_ADMIN_TOKEN', '')
      commit('SET_LOGGED', false)
      commit('SET_ADMIN_ERROR', '')
    },
    async GET_YOOKASSA_ADMIN_CONFIG({ state }) {
      const response = await axios.post(`${apiUrl}/admin/payment/config`, { admin_token: state.token })
      const payload = response && response.data && response.data.data
      if (String(response && response.data && response.data.status) !== '200') {
        throw new Error(payload && payload.text ? payload.text : 'Не удалось получить настройки ЮKassa')
      }
      return payload || {}
    },
    async SET_YOOKASSA_MODE({ state }, mode) {
      try {
        const response = await axios.post(`${apiUrl}/admin/payment/mode`, {
          admin_token: state.token,
          mode: String(mode || '')
        })
        const payload = response && response.data && response.data.data
        if (String(response && response.data && response.data.status) !== '200') {
          throw new Error(payload && payload.text ? payload.text : 'Не удалось переключить режим ЮKassa')
        }
        return payload || {}
      } catch (error) {
        const payload = error && error.response && error.response.data && error.response.data.data
        throw new Error(payload && payload.text ? payload.text : error.message || 'Не удалось переключить режим ЮKassa')
      }
    },
    async GET_PATTERNS() {
      const response = await axios.post(`${apiUrl}/equipment/get-patterns`, {})
      return response.data.data
    },
    async UPDATE_EQUIPMENT(context, data) {
      return axios.post(`${apiUrl}/equipment/update-equipment`, data)
    },
    async ADD_EQUIPMENT(context, data) {
      return axios.post(`${apiUrl}/equipment/add-equipment`, data)
    },
    async REMOVE_EQUIPMENT_IMAGE({ state }, data) {
      try {
        const response = await axios.post(`${apiUrl}/equipment/admin/remove-equipment-image`, {
          ...(data || {}),
          admin_token: state.token
        })
        const payload = response && response.data && response.data.data
        if (String(response && response.data && response.data.status) !== '200') {
          throw new Error(payload && payload.text ? payload.text : 'Не удалось убрать изображение')
        }
        return payload || {}
      } catch (error) {
        const payload = error && error.response && error.response.data && error.response.data.data
        throw new Error(payload && payload.text ? payload.text : error.message || 'Не удалось убрать изображение')
      }
    }
  }
}
